export default function Footer() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const el = document.querySelector(target);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-secondary-900 text-white">
      <div className="px-4 md:px-6 py-14 md:py-20 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-white text-lg"></i>
              </div>
              <span className="text-lg font-semibold font-serif">苹果视频</span>
            </div>
            <p className="text-sm text-white/60 leading-relaxed mb-4">
              苹果视频 — 专业免费高清影视在线观看平台。汇聚久久视频、芒果视频、97视频、丝瓜视频等全网热门资源，50000+高清电影电视剧全集免费看，不缓冲流畅播放。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200">
                <i className="ri-wechat-line text-white text-sm"></i>
              </a>
              <a href="#hero" className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200">
                <i className="ri-weibo-line text-white text-sm"></i>
              </a>
              <a href="#hero" className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200">
                <i className="ri-bilibili-line text-white text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-4 font-serif">快速导航</h3>
            <div className="flex flex-col gap-2.5">
              <a href="#hero" onClick={(e) => handleScroll(e, '#hero')} className="text-sm text-white/60 hover:text-white transition-colors">首页</a>
              <a href="#carousel" onClick={(e) => handleScroll(e, '#carousel')} className="text-sm text-white/60 hover:text-white transition-colors">焦点专题</a>
              <a href="#media" onClick={(e) => handleScroll(e, '#media')} className="text-sm text-white/60 hover:text-white transition-colors">精彩片段</a>
              <a href="#faq" onClick={(e) => handleScroll(e, '#faq')} className="text-sm text-white/60 hover:text-white transition-colors">常见问题</a>
              <a href="#about" onClick={(e) => handleScroll(e, '#about')} className="text-sm text-white/60 hover:text-white transition-colors">关于我们</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-4 font-serif">热门分类</h3>
            <div className="flex flex-col gap-2.5">
              <a href="#index" onClick={(e) => handleScroll(e, '#index')} className="text-sm text-white/60 hover:text-white transition-colors">久久视频专区</a>
              <a href="#index" onClick={(e) => handleScroll(e, '#index')} className="text-sm text-white/60 hover:text-white transition-colors">芒果视频专区</a>
              <a href="#index" onClick={(e) => handleScroll(e, '#index')} className="text-sm text-white/60 hover:text-white transition-colors">97视频专区</a>
              <a href="#index" onClick={(e) => handleScroll(e, '#index')} className="text-sm text-white/60 hover:text-white transition-colors">丝瓜视频专区</a>
              <a href="#ranking" onClick={(e) => handleScroll(e, '#ranking')} className="text-sm text-white/60 hover:text-white transition-colors">热播排行榜</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-4 font-serif">合作伙伴</h3>
            <p className="text-sm text-white/40 leading-relaxed mb-3">
              感谢以下合作伙伴对苹果视频的支持与信任，共同为用户提供优质影视内容。
            </p>
            <div className="grid grid-cols-2 gap-2">
              <div className="h-10 rounded-lg bg-white/5 flex items-center justify-center text-xs text-white/30">
                合作伙伴
              </div>
              <div className="h-10 rounded-lg bg-white/5 flex items-center justify-center text-xs text-white/30">
                合作伙伴
              </div>
              <div className="h-10 rounded-lg bg-white/5 flex items-center justify-center text-xs text-white/30">
                合作伙伴
              </div>
              <div className="h-10 rounded-lg bg-white/5 flex items-center justify-center text-xs text-white/30">
                合作伙伴
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-white/40">
              &copy; 2020-2026 苹果视频. 本站内容仅供学习交流，请于下载后24小时内删除。
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-white/40 hover:text-white/60 transition-colors">服务条款</a>
              <a href="#hero" className="text-xs text-white/40 hover:text-white/60 transition-colors">隐私政策</a>
              <a href="#hero" className="text-xs text-white/40 hover:text-white/60 transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}